// utils/youtube.ts
//
// Turn a host-pasted YouTube live URL into an embeddable iframe src. The host
// pastes whatever the YouTube UI gives them; we accept the common shapes:
//   watch?v=ID · youtu.be/ID · /live/ID · /embed/ID   -> embed/ID
//   /channel/UC.../live                               -> embed/live_stream?channel=UC...
// A bare @handle/live URL can't be resolved to a channel id on the client, so it
// returns null and the player falls back to an "open on YouTube" link.

const VIDEO_ID = /(?:youtu\.be\/|\/live\/|\/embed\/|[?&]v=)([A-Za-z0-9_-]{11})/;
const CHANNEL_ID = /\/channel\/(UC[A-Za-z0-9_-]+)/;

export const toEmbedUrl = (raw?: string): string | null => {
  if (!raw) return null;
  const url = raw.trim();

  const vid = url.match(VIDEO_ID)?.[1];
  if (vid) return `https://www.youtube.com/embed/${vid}?autoplay=1&playsinline=1`;

  const channel = url.match(CHANNEL_ID)?.[1];
  if (channel)
    return `https://www.youtube.com/embed/live_stream?channel=${channel}&autoplay=1&playsinline=1`;

  return null;
};
